import { Component, OnInit } from "@angular/core";
import {
  Router,
  RouteConfigLoadStart,
  ResolveStart,
  RouteConfigLoadEnd,
  ResolveEnd
} from "@angular/router";
import { SharedDataService } from "../services/shared.service";
// import { SharedDataService } from "../../IoTCore/dashboard-builder/services/shared.service";

@Component({
  selector: "app-layout",
  templateUrl: "./layout.component.html",
  styleUrls: ["./layout.component.css"]
})
export class LayoutComponent implements OnInit {
  sidebarCollapsed = false;
  constructor(
    private router: Router,
    public _SharedService: SharedDataService
    ) {}
  moduleLoading = true;
  sideBarLoaded = false;

  public ngOnInit() {
    // this.sideBarLoaded = this._SharedService.isSidebarLoaded;

    this.router.events.subscribe(event => {
      if (
        event instanceof RouteConfigLoadStart ||
        event instanceof ResolveStart
      ) {
        this.moduleLoading = true;
      }
      if (event instanceof RouteConfigLoadEnd || event instanceof ResolveEnd) {
        this.moduleLoading = false;
      }
    });
    setTimeout(() => {
      window.scrollTo(0, 0);
      this.moduleLoading = false;
    }, 2000);
  }

  sidebarCollapse($event) {
    
    this.sidebarCollapsed = $event.sidebarCollapsed;
  }
}
